module.exports = __webpack_public_path__ + "img/chengben.ff85b7a4.png";